import { type SafeHtml } from 'kerfjs';

import { settingsTab } from '../../../data/state.js';
import { OrganizationSettingsView } from './organization-settings-view.js';
import { PersonalSettingsView } from './personal-settings-view.js';
import { ProjectSettingsView } from './project-settings-view.js';

export function SettingsView(): SafeHtml {
  if (settingsTab.value === 'organization') return <OrganizationSettingsView />;
  if (settingsTab.value === 'project') return <ProjectSettingsView />;
  return <PersonalSettingsView />;
}
